import * as React from 'react';
import classNames from 'styles/utils/classNames';
import type { MarketSessionPhase } from 'utils/shared/time/marketSession';
import { SESSION_TONES } from './sessionTones';

interface Props {
  phase: MarketSessionPhase;
  /** Ping only while a session is genuinely running — never on a closed market. */
  live: boolean;
  size?: 'sm' | 'md';
}

/**
 * The dot. One shape, four colours, used in the page header and beside every live spot price so
 * the two can never disagree about what session it is.
 */
export default function StatusDot({ phase, live, size = 'md' }: Props) {
  const tone = SESSION_TONES[phase];
  const box = size === 'sm' ? 'h-1.5 w-1.5' : 'h-2 w-2';

  return (
    <span className={classNames('relative flex shrink-0', box)} aria-hidden="true">
      {live && (
        <span
          className={classNames(
            'absolute inline-flex h-full w-full animate-live-ping rounded-full opacity-75 motion-reduce:animate-none',
            tone.ping,
          )}
        />
      )}
      <span className={classNames('relative inline-flex rounded-full', box, tone.dot)} />
    </span>
  );
}
